// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__9s9UZ","total":"Cart_total__cpk1v","actions":"Cart_actions__bAHFt","button--alt":"Cart_button--alt__p46H9","button":"Cart_button__j4oqq"};